import type { Flights } from "@b2bportal/air-disruption-api";
import { useDisruptionStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreDisruptionComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Button, ToggleGroup } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./DisruptionExerciseDateFilter.module.scss";

export interface DisruptionExerciseDateFilterProps {
  flights?: Flights;
  defaultSelection: "today" | "tomorrow";
  handleDateChange: (isToday: boolean) => void;
  handleOpenMobileFilter: () => void;
  todayTitle: string;
  tomorrowTitle: string;
}

export const DisruptionExerciseDateFilter = (
  props: DisruptionExerciseDateFilterProps
) => {
  const {
    defaultSelection,
    handleOpenMobileFilter,
    handleDateChange,
    todayTitle,
    tomorrowTitle,
  } = props;

  const COMPONENT_KEY = CoreDisruptionComponent.DisruptionExerciseDateFilter;
  const styles = useDisruptionStyles(COMPONENT_KEY, defaultStyles);
  const [_, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t } = useI18nContext();

  return (
    <div className={cn("dateFilterContainer")}>
      <div className={cn("disruptionButtonsDates")}>
        <ToggleGroup
          type="single"
          value={defaultSelection}
          items={[
            { id: "today", label: todayTitle },
            { id: "tomorrow", label: tomorrowTitle },
          ]}
          onValueChange={({ id }) => handleDateChange(id === "today")}
          render={(item) => (
            <div className={cn("button", { notSelected: !item.selected })}>
              {item.item.label}
            </div>
          )}
        />
      </div>
      <Button
        onClick={handleOpenMobileFilter}
        className={clsx(cn("filter"), cn("buttonMobile"), cn("button"))}
      >
        {t("filter")}
      </Button>
    </div>
  );
};

export default DisruptionExerciseDateFilter;
